<script setup lang="ts">
import { ref } from 'vue';
import ToolTip from '../ToolTip.vue';
import { locale } from '../../locale';

const btn = ref<HTMLElement | null>(null)
</script>
<template>
  <button ref="btn" class="right-button">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39961 4.79999L15.5996 12L8.39961 19.2"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <ToolTip :placement="'top'" :reference="btn">{{locale.nextPage}}</ToolTip>
  </button>
</template>
<style scoped>
.right-button {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: rgba(73, 73, 73, 0.85);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
}

.right-button:disabled {
  pointer-events: none;
}
</style>
